import { useAuth } from "../contexts/CustomContextHook/useAuth";
import React from 'react'
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { useHotel2 } from "../contexts/HotelContext";

const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (error) {
    return null;
  }
}



const AuthVerify = ({ history }) => {


  // const { Hotel, setHotel } = useHotel()

  const { HotelId, setHotelId, HotelName, setHotelName } = useHotel2()
  const { UserToken, setUserToken } = useAuth();

  const logout = () => {

    // console.log('UserToken---', UserToken);




    // localStorage.setItem('Token', '');
    // localStorage.setItem('Expiry', '');
    // localStorage.setItem('LoggedInUserId', '');
    // localStorage.setItem('UserRoles', []);
    // localStorage.setItem('FirstName', '');
    // localStorage.setItem('LastName', '');
    // localStorage.setItem('Email', '');

    setHotelId('0');
    setHotelName("");

    localStorage.setItem("SignOut", 'true');


    localStorage.removeItem("WeeklyWrapUpObj");
    localStorage.removeItem("WeeklyWrapUpObjEditedHotelId");
    localStorage.removeItem('ReturnURL');
    localStorage.removeItem('FormEditingMode');
    localStorage.removeItem('IsEditOperation');


    localStorage.removeItem('PayrollReportObjEditedHotelId');
    localStorage.removeItem('PayrollReportObjFormEditingMode');
    localStorage.removeItem('IsPayrollReportObjEditOperation');
    localStorage.removeItem('PayrollReportReturnURL');
    localStorage.removeItem('PayrollReportObj');


    setUserToken('', '', '', [], '', '', '');

  }

  // console.log('hisoty :: ', history);
  console.log('*************&&&&&&F$$$$');


  if (UserToken.token !== "") {
    const decodedJwt = parseJwt(UserToken.token);

    console.log((decodedJwt.exp * 1000) > Date.now());

    if (decodedJwt.exp * 1000 < Date.now()) {

      toast.error('Your session has expired. Please login again')

      logout()

      // console.log('decodedJwt ', decodedJwt.exp * 1000);
      // console.log('Date.now() ', Date.now());

    }

    return (
      <div></div>
    )
  }
}

export default withRouter(AuthVerify);